import en from "./en.json";
import he from "./he.json";
import { type LocaleKey, SUPPORTED_LOCALES } from "../lib/locale";

export { SUPPORTED_LOCALES, type LocaleKey };
export type SiteContent = typeof en;

export const siteContent: Record<LocaleKey, SiteContent> = {
  en,
  he
};

export function getSiteContent(locale: LocaleKey): SiteContent {
  return siteContent[locale] ?? siteContent.en;
}
